module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/30.9896e299.png";